import Head from "next/head";

import { getAllBlogPosts } from "lib/remoteContent";
import { generateRssFeed } from "lib/generateRssFeed";

import MarkdownLayout from "components/MarkdownLayout";

import BlogCard from "components/blog/BlogCard";

import type { GetStaticProps } from "next";
import type { Page } from "types/page";

import type { BlogPost } from "lib/remoteContent";

type PageProps = {
  posts: BlogPost[];
};

export const getStaticProps: GetStaticProps<PageProps> = async () => {
  await generateRssFeed();
  const posts = await getAllBlogPosts();

  return {
    props: {
      posts,
    },
  };
};

const title = "Raycast - Blog";

const Blog: Page<PageProps> = ({ posts }) => {
  return (
    <>
      <Head>
        <link rel="alternate" type="application/rss+xml" href="https://www.raycast.com/rss/feed.xml" title={title} />
        <link rel="alternate" type="application/feed+json" href="https://www.raycast.com/rss/feed.json" title={title} />
        <link rel="alternate" type="application/atom+xml" href="https://www.raycast.com/rss/feed.atom" title={title} />
      </Head>
      <MarkdownLayout
        separatedIntro={false}
        meta={{
          title: "Blog",
          desc: "We write stuff from time to time that might be interesting 🤷‍",
        }}
      >
        {posts.map((post) => (
          <BlogCard key={post.slug} post={post} />
        ))}
      </MarkdownLayout>
    </>
  );
};

export default Blog;
